import KlarnaMarketing from 'components/Klarna/KlarnaMarketing/KlarnaMarketing';

export default KlarnaMarketing;
